/**
 * Identidad de la compilación que se está ejecutando.
 *
 * Se anuncia en consola al arrancar para que, ante cualquier error, la primera
 * pregunta —¿estoy viendo el código nuevo?— se responda mirando la misma
 * pantalla donde salió el error, sin adivinar.
 */
declare const __BUILD_ID__: string;
declare const __BUILT_AT__: string;

export const BUILD_ID = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';
export const BUILT_AT = typeof __BUILT_AT__ === 'string' ? __BUILT_AT__ : '';

export function announceBuild(): void {
  const cuando = BUILT_AT ? new Date(BUILT_AT).toLocaleString() : 'desconocido';
  console.info(`%c29100 Cloud%c build ${BUILD_ID} · ${cuando}`, 'font-weight:600', 'color:#94A3B8');
}
